const spProject = {
  scm: {},
  trade: [],
}

export default spProject;
